// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import AchievementType from "./achievement_type_type";


export default __t.row({
  id: __t.u64().primaryKey(),
  userId: __t.u64().name("user_id"),
  get achievementType() {
    return AchievementType.name("achievement_type");
  },
  unlockedAt: __t.u64().name("unlocked_at"),
});
